import { Navigate, useParams } from 'react-router-dom';
import { getBibleResumePath } from '../../services/bibleResumePath';
import { telegramService } from '../../services/telegram';
import { isBfRedesignEnabled } from '../../utils/bfRedesignFlag';

/** Сегменты пути, не являющиеся переводом Библии (чтобы /tasks не ушёл в /tasks/1/1) */
const RESERVED_TOP_LEVEL = new Set(['tasks', 'create', 'settings', 'login']);

export default function BibleHomeRedirect() {
  const { translation } = useParams();

  if (translation && RESERVED_TOP_LEVEL.has(translation)) {
    return <Navigate to="/" replace />;
  }

  if (isBfRedesignEnabled() && translation) {
    /* В Telegram Mini App — сразу последняя глава/стих (история чтения), не дашборд и не полноэкранный чат. */
    if (telegramService.isTelegramWebApp) {
      return <Navigate to={getBibleResumePath(translation)} replace />;
    }
    return <Navigate to={`/${translation}/home`} replace />;
  }

  const to = getBibleResumePath(translation);
  return <Navigate to={to} replace />;
}
